/* eslint-disable @typescript-eslint/no-use-before-define */

import { getDfedsColors } from './dfedsColors';

export function getDfedsColorIterator() {
  const colors = getDfedsColors();

  return {
    getNextColor,
    beFriendly,
  };

  function getNextColor(withKeys: Record<string, any>) {
    const keyCount = Object.keys(withKeys).length;
    const availableColors = colors.length;
    const newIndex = keyCount % availableColors;
    return colors[newIndex];
  }

  function beFriendly(type: string): string {
    return type.replace(/_/g, ' ').replace(/\b\w/g, (l) => {
      return l.toUpperCase();
    });
  }
}
